import { useEffect, useState } from "react";
import { Box, Button, Card, CardActionArea, CardActions, CardContent, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import MyUserService from "../../services/myUser";
import { getClienteData } from '../../actions/datoscliente';
import { IMisDatos }  from "./iMisDatos";
import colores from '../../shared/constants/styles';
import Dolar from '../../common/dolar';

const TiposEmails = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [hoveredCardId, setHoveredCardId] = useState<number | null>(null);
    const [misDatos, setMisDatos] = useState<IMisDatos[] | null>();

    useEffect(() => {
        dispatch(getClienteData(MyUserService.getMyUser().clienteId));
    }, []);

    useEffect(() => {
        if (props.tipoEmailContactoResponse) {
            setMisDatos(props.tipoEmailContactoResponse.$values);
        }
    }, [props.tipoEmailContactoResponse]);

    const handleMouseEnter = (id: number) => {
        setHoveredCardId(id);
    };

    const handleMouseLeave = () => {
        setHoveredCardId(null);
    };

    const handleVerMas = async (tipoEmailId: string, tipoEmailNombre: string, idSync: string) => {
        history.push({
            pathname: `/clientes/contacto/${tipoEmailId}/${idSync}`,
            state: { tipoEmailNombre }
        });
    };

    return (
        <>
            <div style={{ backgroundColor: colores.grisClaro, overflow: "hidden", clear: "both" }}>
                <Dolar />
                <div className='d-flex justify-content-center'>
                    <hr style={{ width: "90%", color: "black" }} />
                </div>
                <div className='d-flex justify-content-between flex-wrap align-items-center' style={{ marginBottom: "0.600rem", paddingRight: "3rem", paddingLeft: "21px" }}>
                    <h1 className="fw-bolder" style={{ margin: "1rem 3.5rem" }}>CONFIGURACIÓN DE CORREOS</h1>
                </div>
            </div>

            <Box
                sx={{
                    m: 10,
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)'
                    },
                    gap: 2
                }}
            >
                {misDatos?.map((tipoEmail) => {
                    const isHovered = hoveredCardId === tipoEmail.tipoEmailId;

                    return (
                        <Card
                            key={tipoEmail.tipoEmailId}
                            sx={{
                                transition: '0.3s',
                                backgroundColor: isHovered ? "rgba(255, 0, 0, 0.8)" : "#f5f0f0",
                                '&:hover': {
                                    boxShadow: 6,
                                    transform: 'scale(1.02)',
                                    borderColor: 'primary.main'
                                }
                            }}
                            onMouseEnter={() => handleMouseEnter(tipoEmail.tipoEmailId)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <CardActionArea
                                sx={{ cursor: 'pointer' }}
                                onClick={() => handleVerMas(`${tipoEmail.tipoEmailId}`, `${tipoEmail.tipoEmailNombre}`, `${tipoEmail.idSync}`)}
                            >
                                <CardContent sx={{ height: '100%' }}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography style={{ color: isHovered ? "white" : "inherit" }} variant="h5">
                                            {tipoEmail.tipoEmailNombre}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" style={{ color: isHovered ? "white" : "inherit" }} mt={1}>
                                        <strong>Email:</strong> {tipoEmail.email ? tipoEmail.email : "N/A"}
                                    </Typography>
                                </CardContent>
                                <CardActions sx={{ height: '100%' }}>
                                    <Button
                                        style={{ color: isHovered ? "white" : "red", marginLeft: "1vw" }}
                                        onClick={() => handleVerMas(`${tipoEmail.tipoEmailId}`, `${tipoEmail.tipoEmailNombre}`, `${tipoEmail.idSync}`)}
                                        endIcon={<ArrowForwardIcon />}
                                    >
                                        VER MÁS
                                    </Button>
                                </CardActions>
                            </CardActionArea>
                        </Card>
                    );
                })}
            </Box>
        </>
    );
};

export default connect(
    (state: any) => ({
        tipoEmailContactoResponse: state.datoscliente.tipoEmailContactoResponse,
        success: state.datoscliente.success,
        loading: state.datoscliente.loading
    }),
    dispatch => ({
        getClienteData: (clienteId: string) => dispatch(getClienteData(clienteId))
    })
)(TiposEmails);
